import { RouteRecordRaw } from "vue-router";

export const registerSignInRoute: RouteRecordRaw = {
  path: "sign_in",
  name: "SIGN_IN_PAGE",
  component: () => import("@/pages/auth/SignIn.vue"),
  meta: {
    title: "Вход",
  },
};

export const registerSignUpRoute: RouteRecordRaw = {
  path: "sign_up",
  name: "SIGN_UP_PAGE",
  component: () => import("@/pages/auth/SingUp.vue"),
  meta: {
    title: "Регистрация",
  },
};
